import { Cell } from '@/design_system/Table/Table';
import { ShipmentWithRelations } from '@/models/shipment';

import { ShipmentOrigin } from '../../ShipmentOrigin';

export const ShipmentOriginCell = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  return (
    <Cell>
      <ShipmentOrigin shipment={shipment} />
    </Cell>
  );
};
